var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.tagClasses},[_c('span',{ref:"value",staticClass:"tag-text"},[_vm._t("default")],2),(_vm.removable)?_c('div',{staticClass:"tag-close",on:{"click":_vm.handleRemoveClick}},[_c('svgicon',{attrs:{"name":"close"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }